export enum BannerTypes {
  Basic = 'basic',
  Progressive = 'progressive',
}

export enum ActionType {
  Web = 'web',
  Native = 'native',
  Popup = 'popup',
  ExternalUrl = 'external_url',
}
